import React, { useState } from "react";
import { Col, Container, Modal, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import {
  numberFormat,
  toastStyle,
  refreshPage,
  getTodayDateISO,
  formatTime,
  dateFormat,
  numberFormatInt,
} from "../../../Helpers/Utils/Common";
import toast from "react-hot-toast";
import TransferModal from "./../Transfer/TransferModal";
import Moment from "moment";
import cleanLogo from "../../../Assets/Images/Login/transparent_bg.png";
import { getGatePass } from "../../../Helpers/apiCalls/Inventory/GatePassApi";
import Footer from "../../../Components/Footer/Footer";

export default function GatePassView() {
  const { id } = useParams();
  let navigate = useNavigate();

  const [inactive, setInactive] = useState(true);
  const [isSet, setIsSet] = useState(false);
  const [items, setItems] = useState([]);
  const [newTransfer, setNewTransfer] = useState({
    gate_pass_date: "",
    branch_from: "",
    branch_from_name: "",
    encoded_by: "",
    branch_to: "",
    branch_to_name: "",
    remarks: "",
  });
  const [itemData, setItemData] = useState([]);
  const [gatePassDetails, setGatePassDetails] = useState({});
  const [gatePassItem, setGatePassItem] = useState([]);
  /* print modal handler */
  const [showPrintModal, setShowPrintModal] = useState(false);
  const handleShowPrintModal = () => setShowPrintModal(true);
  const handleClosePrintModal = () => setShowPrintModal(false);
  const [printPI, setPrintPI] = useState([]);

  async function handlePrintPI() {
    toast.loading("Printing Transfer Details", { style: toastStyle() });
    handleClosePrintModal();
    setTimeout(() => {
      toast.dismiss();
      Print();
    }, 1000);
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print(printContents);
    document.body.innerHTML = originalContents;
    refreshPage();
  }

  async function fetchGatePass() {
    const response = await getGatePass(id, "");

    if (response.data) {
      var data = response.data.data[0];
      setGatePassDetails(data)
      setGatePassItem(data.gate_pass_items ? data.gate_pass_items : [])
      // setIsSet(true);
    }
  }

  // INVOICE REMOVAL HANDLER
  function handleRemoveItem(id) {
    const rowId = id;
    const newItemList = [...itemData];
    newItemList.splice(rowId, 1);
    setItemData(newItemList);
  }

  function renderGatePassTable() {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th>Quantity</th>
            <th>Unit</th>
            <th>Description</th>
            <th>Consignment No.</th>
          </tr>
        </thead>
        <tbody>
          {/* {isSet */}
            {/* ? gatePassItem.map((item, index) => { */}
            {gatePassItem.map((item) => {
                return (
                  <tr key={item.id}>
                    <td className="franchise-td-gray">
                      {numberFormatInt(item.qty)}
                    </td>
                    <td className="franchise-td-gray">{item.unit}</td>
                    <td className="franchise-td-gray">{item.description}</td>
                    <td className="franchise-td-gray">{item.consignment_no}</td>
                  </tr>
                );
              })}
            {/* : ""} */}
        </tbody>
      </Table>
    );
  }

  React.useEffect(() => {
      fetchGatePass();
  }, []);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"TRANSFERS"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <div className="d-flex justify-content-between d-flex-responsive">
          <h1 className="page-title mb-4">GATE PASS DETAILS </h1>
          <div className="review-po">
            <span className="pe-5">GATEPASS NO.</span>
            <span>{gatePassDetails.id}</span>
          </div>
        </div>
        <div className="review-form mb-3">
            <Container className="" fluid>
              {/* <h4 className="page-subtitle mb-2">GATE PASS DETAILS </h4> */}
              <Row className="review-container py-3">
                <Row>
                  <Col>
                    <span className="review-label nc-modal-custom-row">
                      Gate Pass Date
                    </span>
                  </Col>
                  <Col>
                    <span className="review-label nc-modal-custom-row">
                      Transfer Time
                    </span>
                  </Col>
                  <Col>
                    <span className="review-label nc-modal-custom-row">
                      Transfer No.
                    </span>
                  </Col>
                  <Col>
                    <span className="review-label nc-modal-custom-row">
                      Branch
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span className="review-data">
                      {gatePassDetails.gate_pass_date ? dateFormat(gatePassDetails.gate_pass_date) : ""}
                    </span>
                  </Col>
                  <Col>
                    <span className="review-data">{gatePassDetails?.transfer_time ? formatTime(gatePassDetails?.transfer_time) : ""}</span>
                  </Col>
                  <Col>
                    <span className="review-data">
                      {gatePassDetails.transfer_number}
                    </span>
                  </Col>
                  <Col>
                    <span className="review-data">
                      {gatePassDetails.branch_name}
                    </span>
                  </Col>
                </Row>
              </Row>
              <Row className="review-container py-3">
                <Row>
                  <Col>
                    <span className="review-label nc-modal-custom-row">
                      type
                    </span>
                  </Col>
                  <Col>
                    <span className="review-label nc-modal-custom-row">
                      Driver
                    </span>
                  </Col>
                  <Col>
                    <span className="review-label nc-modal-custom-row">
                      Plate No.
                    </span>
                  </Col>
                  <Col>
                    <span className="review-label nc-modal-custom-row">
                      Delivery Personnel
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span className="review-data">
                      {gatePassDetails.type}
                    </span>
                  </Col>
                  <Col>
                    <span className="review-data">
                      {gatePassDetails.driver}
                    </span>
                  </Col>
                  <Col>
                    <span className="review-data">
                      {gatePassDetails.plate_no}
                    </span>
                  </Col>
                  <Col>
                    <span className="review-data">{gatePassDetails.delivery_personnel}</span>
                  </Col>
                </Row>
              </Row>
              <div className="mt-4 ml-2 d-flex flex-column">
                <span className="ml-2 review-data mb-1 nc-modal-custom-row">
                  ITEMS
                </span>
                <div className="d-flex justify-content-evenly">
                  <div className="print-table mt-3 mx-2">{renderGatePassTable()}</div>
                </div>
              </div>
            </Container>

            <div className="d-flex justify-content-end pt-5">
              <button
                type="button"
                className="button-primary me-3"
                onClick={handleShowPrintModal}
              >
                Print
              </button>
              <button
                type="button"
                className="button-secondary me-3"
                onClick={() => navigate("/gatepass")}
              >
                Close
              </button>
            </div>
        </div>
      </div>

    <Modal show={showPrintModal} onHide={handleClosePrintModal} size="lg" centered>
        <Modal.Header className="return-header">
            <span className="text-warning"> PLEASE CONFIRM </span>
        </Modal.Header>
        <Modal.Body className="return-body text-center">
            <span>Are you sure you want to print this Gatepass? </span>
        </Modal.Body>
        <Modal.Footer className="return-footer">
            <button type="button" className="button-secondary" onClick={handleClosePrintModal}>Cancel</button>
            <button type="button" className="button-primary" onClick={handlePrintPI}>Proceed</button>
        </Modal.Footer>
    </Modal>


      {/* PRINT VIEW */}
      <div className="print-container px-3 py-2 display-none" id="printablediv">
        <div className="text-end print-header d-flex flex-column">
          <span>GATEPASS NO. {gatePassDetails.id}</span>
          <span className="text-uppercase">
            {Moment(getTodayDateISO()).format("MMMM DD, yyyy")}
          </span>
        </div>
        <div className="d-flex justify-content-center py-1">
          <img alt="logo" src={cleanLogo} className="print-logo" />
        </div>
        <div className="print-body mt-5">
            <Container fluid>
                <h4 className="page-subtitle mb-2">GATE PASS DETAILS </h4>
                <Row className="review-container py-3">
                <Col>
                    <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                        Transfer Date:
                    </Col>
                    <Col xs={7} className="print-data">
                        {gatePassDetails.gate_pass_date ? dateFormat(gatePassDetails.gate_pass_date) : ""}
                    </Col>
                    </div>
                    <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                        Transfer Time:
                    </Col>
                    <Col xs={7} className="print-data">
                        {gatePassDetails?.transfer_time ? formatTime(gatePassDetails?.transfer_time) : ""}
                    </Col>
                    </div>
                    <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                        Branch:
                    </Col>
                    <Col xs={7} className="print-data">
                        {gatePassDetails.branch_name}
                    </Col>
                    </div>
                    <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                        Type:
                    </Col>
                    <Col xs={7} className="print-data">
                        {gatePassDetails.type}
                    </Col>
                    </div>
                </Col>
                <Col>
                    <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                        Driver:
                    </Col>
                    <Col xs={7} className="print-data">
                        {gatePassDetails.driver}
                    </Col>
                    </div>
                    <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                        Plate No.:
                    </Col>
                    <Col xs={7} className="print-data">
                        {gatePassDetails.plate_no}
                    </Col>
                    </div>
                    <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                        Customer:
                    </Col>
                    <Col xs={7} className="print-data">
                        {gatePassDetails.customer}
                    </Col>
                    </div>
                    <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                        Delivery Personnel:
                    </Col>
                    <Col xs={7} className="print-data">
                        {gatePassDetails.delivery_personnel}
                    </Col>
                    </div>
                </Col>
                </Row>
            </Container>

            <div className="mt-4 d-flex flex-column mb-3">
                <span className="review-data mb-2 nc-modal-custom-row">
                APPLIED TO THE FOLLOWING ITEMS
                </span>
                <div className="print-table">{renderGatePassTable()}</div>
            </div>
            <div className="print-signatures">
                {/* <span className=""> </span> */}
                <span className="text-center text-uppercase print-label fw-bold">
                {gatePassDetails.added_by_name}
                </span>
            </div>
            <div className="print-signatories pb-4 mb-4">
                {/* <span></span> */}
                <span>Prepared by</span>
            </div>
        </div>
      </div>
      <Footer/>
    </div>
  );
}
